import { render, staticRenderFns } from "./AcademicModal.vue?vue&type=template&id=1093283e&"
import script from "./AcademicModal.vue?vue&type=script&lang=js&"
export * from "./AcademicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports